import styled from 'styled-components'

const S = {};

S.BitvilleContainer = styled.div` 

`;

S.Cover = styled.div`
    background: rgba(0,0,0,0.5);
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 5;
`;

export default S;
